import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import FilterCheckbox from './FilterCheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
function IncludeChatAndPhoneTicketsCheckbox(props) {
  const includeChatAndPhoneTickets = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters.includeChatAndPhoneTickets);
  return /*#__PURE__*/_jsx(FilterCheckbox, {
    "data-test-id": "filter-checkbox",
    defaultValue: includeChatAndPhoneTickets,
    helpLangPath: "app.filter.panel.includeChatAndPhoneTickets.help",
    labelLangPath: "app.filter.panel.includeChatAndPhoneTickets.label",
    onCheck: props.onCheck
  });
}
IncludeChatAndPhoneTicketsCheckbox.propTypes = {
  onCheck: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(IncludeChatAndPhoneTicketsCheckbox);